(function () {
  class WildSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.initialised = false;
      this.wildActive = false;
      this.isLastBoost = false;

      this.wildSymbols = [];
      this.wildType = undefined;

      this.boostAnims = [];

      this.superWildPhase = undefined; // 2 = bottom, 1 = mid, 0 = top

      const self = this;

      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState("IDLE", function () {
        self.update_idle();
      });
      this.stateMachine.addState("PLAYWILD", function () {
        self.update_playWild();
      });
      this.stateMachine.addState("PLAYBOOSTWILD", function () {
        self.update_playBoostWild();
      });
      this.stateMachine.addState("PLAYSUPERWILD", function () {
        self.update_playSuperWild();
      });
      this.stateMachine.addState("PLAYEACHWAYWILD", function () {
        self.update_playEachWayWild();
      });
      this.stateMachine.addState("PLAYMOVEBOOSTWILD", function () {
        self.update_playMoveBoostWild();
      });
    }

    //////////////////////////////////////////////////
    update_idle() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        this.phase.reset();
      }
    }

    //////////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    //////////////////////////////////////////////////
    onLayoutComplete() {
      let baseName =
        "wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer";

      this.wildOverlayContainer = resourceManager.get(baseName);
      this.wildOverlayContainer.visible = false;

      this.wildBaseAnim = resourceManager.get(
        "wildSymbolAnimator:wildSymbolAnimator:wildBase"
      );
      this.wildBaseAnim.visible = false;

      this.wildBaseAnim2 = resourceManager.get(
        "wildSymbolAnimator:wildSymbolAnimator:wildBase2"
      );
      this.wildBaseAnim2.visible = false;

      this.flashAnim = resourceManager.get(
        "wildSymbolAnimator:wildSymbolAnimator:flashAnim"
      );
      this.flashAnim.visible = false;

      // used for multiple boosts to fire across
      this.boostOverlay = [
        // resourceManager.get(baseName + ":boostTopOverlay"),
        resourceManager.get(baseName + ":boostBottomOverlay"),
      ];
      for (let x = 0; x < this.boostOverlay.length; x++) {
        this.boostOverlay[x].alpha = 0;
        this.boostOverlay[x].scale.x = 1;
        this.boostOverlay[x].scale.y = 1;
      }

      this.wildTexts = [];

      // These are order dependant in the array to match the wild type ( 0,1,2,3 )
      let baseWild = [undefined, undefined];
      this.wildTexts.push(baseWild);

      let boostWild = [
        // resourceManager.get(baseName + ":boostTop"),
        resourceManager.get(baseName + ":boostBottom"),
      ];
      this.wildTexts.push(boostWild);

      let superWild = [
        resourceManager.get(baseName + ":superTop"),
        // resourceManager.get(baseName + ":superBottom"),
      ];
      this.wildTexts.push(superWild);

      for (let i = 0; i < this.wildTexts.length; i++) {
        for (let j = 0; j < this.wildTexts[i].length; j++) {
          if (this.wildTexts[i][j] !== undefined) {
            this.wildTexts[i][j].visible = false;
            this.wildTexts[i][j].scale.x = 1;
            this.wildTexts[i][j].scale.y = 1;
          }
        }
      }

      this.setBoostPositions();

      this.stateMachine.switchState("IDLE");

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    //////////////////////////////////////////////////
    setBoostPositions() {
      let baseName =
        "wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer";

      // this.boostStartTopPos = layoutController.getCurrentPosition(
      //   baseName + ":boostTop"
      // );
      this.boostStartBottomPos = layoutController.getCurrentPosition(
        baseName + ":boostBottom"
      );

      this.targetPosTop =
        layoutController.getCurrentPosition("multiplierTarget");
      this.targetPosBottom = {
        x: this.targetPosTop.x + 25,
        y: this.targetPosTop.y - 10,
      };
    }

    //////////////////////////////////////////////////
    onOrientationChange() {
      this.setBoostPositions();

      // rescale objects
      for (let x = 0; x < this.boostOverlay.length; x++) {
        this.boostOverlay[x].alpha = 0;
        this.boostOverlay[x].scale.x = 1;
        this.boostOverlay[x].scale.y = 1;
      }

      for (let i = 0; i < this.wildTexts.length; i++) {
        for (let j = 0; j < this.wildTexts[i].length; j++) {
          if (this.wildTexts[i][j] !== undefined) {
            this.wildTexts[i][j].visible = false;
            this.wildTexts[i][j].scale.x = 1;
            this.wildTexts[i][j].scale.y = 1;
          }
        }
      }

      // update positions  - wild
      if (this.wildSymbols.length > 0) {
        this.setReelObjPosition(
          this.wildBaseAnim,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );

        if (this.wildSymbols.length > 1) {
          this.setReelObjPosition(
            this.wildBaseAnim2,
            this.wildSymbols[1].reel,
            this.wildSymbols[1].row
          );
        }
      }

      if (this.wildType === 1) {
        // boost text
        this.wildTexts[1][0].visible = true;
        // this.wildTexts[1][1].visible = true;

        // this.wildTexts[1][0].position.set(
        //   this.boostStartTopPos.x,
        //   this.boostStartTopPos.y
        // );
        // this.wildTexts[1][1].position.set(
        //   this.boostStartBottomPos.x,
        //   this.boostStartBottomPos.y
        // );

        // only used when multiple boosts
        // this.boostOverlay[0].position.set(
        //   this.boostStartTopPos.x,
        //   this.boostStartTopPos.y
        // );
        // this.boostOverlay[1].position.set(
        //   this.boostStartBottomPos.x,
        //   this.boostStartBottomPos.y
        // );
      } else if (this.wildType === 2) {
        // super wild
        this.wildTexts[2][0].visible = true;
        // this.wildTexts[2][1].visible = true;

        this.setReelObjPosition(
          this.flashAnim,
          this.wildSymbols[0].reel,
          this.superWildPhase
        );
        this.setReelObjPosition(
          this.wildBaseAnim,
          this.wildSymbols[0].reel,
          this.superWildPhase
        );
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          this.superWildPhase
        );
      } //else if (this.wildType === 3) {
        // // each way wild
        // this.wildTexts[3][0].visible = true;
        // this.wildTexts[3][1].visible = true;
      // }
    }

    ////////////////////////////////////////////////// the initial entry
    playWilds(wildSymbols, wildType) {
      this.wildActive = true;
      this.wildType = wildType;
      this.wildSymbols = wildSymbols;

      if (wildType === 0) {
        // Standard Wild
        soundManager.play("wildLand");
        this.stateMachine.switchState("PLAYWILD");
      } else if (wildType === 1) {
        // Multi Boost Wild
        soundManager.play("boostWildLand");
        this.stateMachine.switchState("PLAYBOOSTWILD");
      } else if (wildType === 2) {
        // Super/Stacked Wild
        soundManager.play("superWildLand");
        this.stateMachine.switchState("PLAYSUPERWILD");
      } else if (wildType === 3) {
        // Each Way Wild
        soundManager.play("eachWayWildLand");
        this.stateMachine.switchState("PLAYEACHWAYWILD");
      }
    }

    //////////////////////////////////////////////////
    moveBoostWild(isLastBoost) {
      this.wildActive = true;
      this.isLastBoost = isLastBoost;
      this.stateMachine.switchState("PLAYMOVEBOOSTWILD");
    }

    //////////////////////////////////////////////////
    wildsActive() {
      return this.wildActive;
    }

    //////////////////////////////////////////////////
    setupOverlays() {
      for (let i = 0; i < this.wildTexts.length; i++) {
        for (let j = 0; j < this.wildTexts[i].length; j++) {
          if (this.wildTexts[i][j] !== undefined) {
            this.wildTexts[i][j].scale.x = 1;
            this.wildTexts[i][j].scale.y = 1;

            if (i === this.wildType) {
              this.wildTexts[i][j].visible = true;
            } else {
              this.wildTexts[i][j].visible = false;
            }
          }
        }
      }

      this.wildOverlayContainer.visible = true;

      this.wildBaseAnim.visible = true;
      this.wildBaseAnim.loop = false;
      this.wildBaseAnim.gotoAndPlay(0);
    }

    //////////////////////////////////////////////////
    // generic function to set various positions to the correct reel and row
    setReelObjPosition(obj, reel, row) {
      let offsetX = 0;
      let offsetY = 0;

      switch (layoutController.getCurrentLayout()) {
        case "landscape_default":
          offsetX = 95;
          offsetY = 104;
          break;
        case "landscape_mobile":
          offsetX = 85;
          offsetY = 85;
          break;
        case "portrait_default":
          offsetX = 65;
          offsetY = 70;
          break;
        case "portrait_mobile":
          offsetX = 65;
          offsetY = 70;
          break;
      }

      let posX = gameData.reels[reel].position.getX() + offsetX;
      let posY = gameData.reels[reel].position.getY() + row * 180 + offsetY;

      obj.position.set(posX, posY);
    }

    //////////////////////////////////////////////////
    pulseText(progress, pos) {
      if (this.wildType !== 0) {
        // we never pulse the basic wild - safety net here
        let pr = Math.abs(Math.sin(Math.PI * progress));
        // TODO
        // this.wildTexts[this.wildType][pos].scale.x = 1 + 0.15 * pr;
        // this.wildTexts[this.wildType][pos].scale.y = 1 + 0.15 * pr;
      }
    }

    linearInterpolate(P1, P2, delta) {
      var x = P1.x + (P2.x - P1.x) * delta;
      var y = P1.y + (P2.y - P1.y) * delta;

      return { x: x, y: y };
    }

    //////////////////////////////////////////////////
    moveSuperText(reel, rowFrom, rowTo, progress) {
      this.wildBaseAnim.visible = false;
      resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:superTop").visible = true;
      resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer").alpha = 1;
      // resourceManager.get("wildSymbolAnimator:wildSymbolAnimator").alpha = 1;
      // resourceManager.get("wildSymbolAnimator").alpha = 1;

      var offset = systemData.isLandscape ? 95 : 65;

      let posX = gameData.reels[reel].position.getX() + offset;
      let posYFrom =
        gameData.reels[reel].position.getY() + rowFrom * 180 + offset;
      let posYTo = gameData.reels[reel].position.getY() + rowTo * 180 + offset;

      let from = { x: posX, y: posYFrom };
      let to = { x: posX, y: posYTo };

      let newPos = this.linearInterpolate(from, to, progress);

      this.wildOverlayContainer.position.set(newPos.x, newPos.y);
      this.wildOverlayContainer.visible = true;
    }

    //////////////////////////////////////////////////
    update_playWild() {
      // there can be 1 or 2 standard wilds
      if (this.phase.enter()) {
        this.wildBaseAnim = resourceManager.get(
          "wildSymbolAnimator:wildSymbolAnimator:wildBase"
        );
        this.setReelObjPosition(
          this.wildBaseAnim,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setupOverlays();
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );

        if (this.wildSymbols.length > 1) {
          this.wildBaseAnim2.visible = true;
          this.wildBaseAnim2.gotoAndPlay(0);
          this.setReelObjPosition(
            this.wildBaseAnim2,
            this.wildSymbols[1].reel,
            this.wildSymbols[1].row
          );
        }

        //Render each text graphic at 24% original size at the above coords,
        //and grow to 38% when ‘Symbol_Wild’ sequence is playing and reaches frame 14/15.
        //Stagger the text growing so that the top text pulses before the bottom text (see reference vids).

        //When the boost text has done its pulse/grow, move the text graphics over to the ‘Multiplier_Ball’
        //graphic to the left of the reel. Play the ‘Multiplier_Glow’ sequence and
        //increase the multiplier values within the panel (see ref vid).
      }

      if (this.phase.hold()) {
        if (!this.wildBaseAnim.playing && !this.wildBaseAnim2.playing) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        for (let i = 0; i < this.wildSymbols.length; i++) {
          let reelObject = gameData.reels[this.wildSymbols[i].reel];
          reelObject.symbolSprites[
            reelObject.Props.preappertureSymbols + this.wildSymbols[i].row
          ].visible = true;
        }

        this.wildBaseAnim.visible = false;
        this.wildBaseAnim2.visible = false;
        this.wildOverlayContainer.visible = false;
        this.wildActive = false;
        this.wildType = undefined;
        this.wildSymbols = [];
        this.stateMachine.switchState("IDLE");
      }
    }

    //////////////////////////////////////////////////
    update_playSuperWild() {
      // Super wild will always be a 3 high stack - ignore the row values
      // we always want to process bottom to top i.e. row 2, 1, 0
      resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:superTop").visible = false; 
      if (this.phase.enter()) {
        this.wildOverlayContainer.visible = true;
        this.wildBaseAnim = resourceManager.get(
          "wildSymbolAnimator:wildSymbolAnimator:wildStacked"
        );

        this.superWildPhase = 2;

        this.setReelObjPosition(this.wildBaseAnim, this.wildSymbols[0].reel, 2);
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          2
        );
        this.setupOverlays();
        //When the super text has done its pulse/grow, move the text graphics up to the above symbol position (move each text graphic up 190px).
        //Play ‘Symbol_Flash’ sequence and the render ‘Symbol_Wild’ under it when flash sequence reaches frame 14/15.
        //Repeat these steps for the symbol above, if necessary (see ref vid).
      }

      if (this.phase.hold()) {
        if (this.wildBaseAnim.currentFrame >= 14) {
          this.phase.step();
        }
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 0);
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 1);
      }

      // then move overlays up to next position - show base anim and static symbol
      // repeat once more
      if (this.phase.timed(100)) {
      }

      if (this.phase.once()) {
        let reelObject = gameData.reels[this.wildSymbols[0].reel];
        reelObject.setSymbol(
          2,
          resourceManager.getConfiguration().symbols.WildStacked.ID
        );
        reelObject.symbolSprites[
          reelObject.Props.preappertureSymbols + 2
        ].visible = true;

        this.wildBaseAnim.visible = false;
        this.setReelObjPosition(this.wildBaseAnim, this.wildSymbols[0].reel, 1);
        this.superWildPhase = 1;
      }

      //////////////////////////////////////////////////////////////////////
      // move from bottom row to middle
      if (this.phase.timed(300)) {
        this.moveSuperText(this.wildSymbols[0].reel, 2, 1, this.phase.Progress);
      }

      if (this.phase.once()) {
        this.setReelObjPosition(this.flashAnim, this.wildSymbols[0].reel, 1);
        this.flashAnim.visible = true;
        this.flashAnim.gotoAndPlay(0);
      }

      if (this.phase.hold()) {
        if (this.flashAnim.currentFrame >= 14) {
          // soundManager.play("superWildLand");
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        // resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:superTop").visible = true;
        this.wildBaseAnim.visible = true;
        // this.wildBaseAnim.gotoAndPlay(0);
      }

      if (this.phase.hold()) {
        if (this.wildBaseAnim.currentFrame >= 14) {
          this.phase.step();
        }
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 0);
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 1);
      }

      if (this.phase.once()) {
        let reelObject = gameData.reels[this.wildSymbols[0].reel];
        reelObject.setSymbol(
          1,
          resourceManager.getConfiguration().symbols.WildStacked.ID
        );
        reelObject.symbolSprites[
          reelObject.Props.preappertureSymbols + 1
        ].visible = true;

        this.wildBaseAnim.visible = false;
        this.setReelObjPosition(this.wildBaseAnim, this.wildSymbols[0].reel, 0);
        this.superWildPhase = 0;
      }

      if (this.phase.timed(300)) {
        this.moveSuperText(this.wildSymbols[0].reel, 1, 0, this.phase.Progress);
      }

      if (this.phase.once()) {
        this.setReelObjPosition(this.flashAnim, this.wildSymbols[0].reel, 0);
        this.flashAnim.visible = true;
        this.flashAnim.gotoAndPlay(0);
      }

      if (this.phase.hold()) {
        if (this.flashAnim.currentFrame >= 14) {
          // soundManager.play("superWildLand");
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        // resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:superTop").visible = false;
        this.wildBaseAnim.visible = true;
        // this.wildBaseAnim.gotoAndPlay(0);
      }

      if (this.phase.hold()) {
        if (this.wildBaseAnim.currentFrame >= 14) {
          this.phase.step();
        }
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 0);
      }

      if (this.phase.timed(200)) {
        this.pulseText(this.phase.Progress, 1);
      }

      if (this.phase.once()) {
        let reelObject = gameData.reels[this.wildSymbols[0].reel];
        reelObject.setSymbol(
          0,
          resourceManager.getConfiguration().symbols.WildStacked.ID
        );
        reelObject.symbolSprites[
          reelObject.Props.preappertureSymbols + 0
        ].visible = true;

        gsap.to(this.wildOverlayContainer, { duration: 0.3, alpha: 0 });
      }

      if (this.phase.timed(100)) {
      }

      if (this.phase.once()) {
        this.wildBaseAnim.visible = false;
        this.wildOverlayContainer.visible = false;
        this.wildOverlayContainer.alpha = 1;
        this.wildActive = false;
        this.wildType = undefined;
        this.wildSymbols = [];
        this.superWildPhase = undefined;
        this.stateMachine.switchState("IDLE");
      }
    }

    //////////////////////////////////////////////////
    update_playBoostWild() {
      // this applies to wild boost and wild each way
      if (this.phase.enter()) {
        this.wildBaseAnim = resourceManager.get(
          "wildSymbolAnimator:wildSymbolAnimator:wildMultiBoost"
        );
        this.wildTexts[1][0].alpha = 0;
        // this.wildTexts[1][0].alpha = 1;
        // this.wildTexts[1][1].alpha = 1;

        // this.wildTexts[1][0].position.set(
        //   this.boostStartTopPos.x,
        //   this.boostStartTopPos.y
        // );
        // this.wildTexts[1][1].position.set(
        //   this.boostStartBottomPos.x,
        //   this.boostStartBottomPos.y
        // );

        // only used when multiple boosts
        // this.boostOverlay[0].position.set(
        //   this.boostStartTopPos.x,
        //   this.boostStartTopPos.y
        // );
        // this.boostOverlay[1].position.set(
        //   this.boostStartBottomPos.x,
        //   this.boostStartBottomPos.y
        // );

        this.setReelObjPosition(
          this.wildBaseAnim,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setupOverlays();

        this.startPosBase = this.wildBaseAnim.position.get();

        //Render each text graphic at 24% original size at the above coords,
        //and grow to 38% when ‘Symbol_Wild’ sequence is playing and reaches frame 14/15.
        //Stagger the text growing so that the top text pulses before the bottom text (see reference vids).

        //When the boost text has done its pulse/grow, move the text graphics over to the ‘Multiplier_Ball’
        //graphic to the left of the reel. Play the ‘Multiplier_Glow’ sequence and
        //increase the multiplier values within the panel (see ref vid).
      }

      if (this.phase.hold()) {
        if (this.wildBaseAnim.currentFrame >= 29) {
          this.wildBaseAnim.gotoAndStop(0);
          this.phase.step();
        }
      }

      if (this.phase.timed(400)) {
        this.pulseText(this.phase.Progress, 0);
      }

      if (this.phase.timed(400)) {
        this.pulseText(this.phase.Progress, 1);
      }

      if (this.phase.once()) {
      }

      if (this.phase.timed(500)) {
      }

      if (this.phase.once()) {
        this.wildActive = false;
        this.stateMachine.switchState("IDLE");
      }
    }

    //////////////////////////////////////////////////
    update_playMoveBoostWild() {
      if (this.phase.enter()) {
        resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer").alpha = 1;
        resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:boostBottom").alpha = 1;
        resourceManager.get("wildSymbolAnimator:wildSymbolAnimator:wildOverlayContainer:boostBottom").position.x = 90000;
      }

      if (this.phase.once()) {
        this.wildTexts[1][0].alpha = 1;
        // this.wildTexts[1][1].alpha = 1;

        if (!this.isLastBoost) {
          this.boostOverlay[0].alpha = 1;
          // this.boostOverlay[1].alpha = 1;
        }
      }

      if (this.phase.timed(500)) {
        // the positions will be the same regardless of if it's the symbol boost text or the extra overlay boost text
        this.startPosBase = this.wildBaseAnim.position.get();

        // let startPosTop = {
        //   x: this.boostStartTopPos.x,
        //   y: this.boostStartTopPos.y,
        // };
        let startPosBottom = {
          x: this.boostStartBottomPos.x,
          y: this.boostStartBottomPos.y,
        };

        // let tTop = {
        //   x: this.targetPosTop.x - this.startPosBase.x,
        //   y: this.targetPosTop.y - this.startPosBase.y,
        // };
        let tBottom = {
          x: this.targetPosBottom.x + 50 - this.startPosBase.x,
          y: this.targetPosBottom.y - this.startPosBase.y,
        };

        // let newPosTop = this.linearInterpolate(
        //   startPosTop,
        //   tTop,
        //   this.phase.Progress
        // );
        let newPosBottom = this.linearInterpolate(
          startPosBottom,
          tBottom,
          this.phase.Progress
        );

        if (this.isLastBoost) {
          // this.wildTexts[1][0].position.set(newPosTop.x, newPosTop.y);
          this.wildTexts[1][0].position.set(newPosBottom.x, newPosBottom.y);
        } else {
          this.boostOverlay[0].position.set(newPosBottom.x, newPosBottom.y);
          // this.boostOverlay[1].position.set(newPosBottom.x, newPosBottom.y);
        }
      }

      if (this.phase.once()) {
        this.wildActive = false;
        //reelObject.symbolSprites[this.wildSymbols[0].row].visible = true;

        if (this.isLastBoost) {
          let reelObject = gameData.reels[this.wildSymbols[0].reel];
          reelObject.symbolSprites[
            reelObject.Props.preappertureSymbols + this.wildSymbols[0].row
          ].visible = true;

          this.wildBaseAnim.visible = false;
          this.wildOverlayContainer.visible = false;

          this.wildTexts[1][0].alpha = 0;
          // this.wildTexts[1][1].alpha = 0;

          // only clear this down on the final boost
          this.wildType = undefined;
          this.wildSymbols = [];
        }

        this.boostOverlay[0].alpha = 0;
        // this.boostOverlay[1].alpha = 0;

        this.stateMachine.switchState("IDLE");
      }
    }

    //////////////////////////////////////////////////
    update_playEachWayWild() {
      // this applies to wild boost and wild each way
      if (this.phase.enter()) {
        this.wildBaseAnim = resourceManager.get(
          "wildSymbolAnimator:wildSymbolAnimator:wildEachWay"
        );
        this.setReelObjPosition(
          this.wildBaseAnim,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setReelObjPosition(
          this.wildOverlayContainer,
          this.wildSymbols[0].reel,
          this.wildSymbols[0].row
        );
        this.setupOverlays();

        //Render each text graphic at 24% original size at the above coords,
        //and grow to 38% when ‘Symbol_Wild’ sequence is playing and reaches frame 14/15.
        //Stagger the text growing so that the top text pulses before the bottom text (see reference vids).

        //When the boost text has done its pulse/grow, move the text graphics over to the ‘Multiplier_Ball’
        //graphic to the left of the reel. Play the ‘Multiplier_Glow’ sequence and
        //increase the multiplier values within the panel (see ref vid).
      }

      if (this.phase.hold()) {
        if (this.wildBaseAnim.currentFrame >= 29) {
          this.wildBaseAnim.gotoAndStop(0);
          this.phase.step();
        }
      }

      if (this.phase.timed(400)) {
        this.pulseText(this.phase.Progress, 0);
      }

      if (this.phase.timed(400)) {
        this.pulseText(this.phase.Progress, 1);
      }

      // if (this.phase.timed(500)) {
      // }

      if (this.phase.once()) {
        let reelObject = gameData.reels[this.wildSymbols[0].reel];
        reelObject.symbolSprites[
          reelObject.Props.preappertureSymbols + this.wildSymbols[0].row
        ].visible = true;

        this.wildBaseAnim.visible = false;
        this.wildOverlayContainer.visible = false;
        this.wildActive = false;
        this.wildType = undefined;
        this.wildSymbols = [];
        this.stateMachine.switchState("IDLE");
      }
    }

    //////////////////////////////////////////////////
    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new WildSymbolAnimator();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "wildSymbolAnimator",
    create,
    initialise,
    getFilesRequired
  );
})();
